module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./ProfitSharingView.js"));
	}, "MyArchivesView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MyArchivesView!./src/pages/Shop/Member/Personal/ProfitSharing/ProfitSharingView.js
// module id = 1923
// module chunks = 367